import { useId } from "react";

export default function Dropdown({
  label,
  name,
  options = [],
  placeholder = "Select an option",
  emptyOption = false,
  value,
  onChange,
  onBlur,
  required,
  disabled,
  error,
  showError = true,
  register,
  rules,
  className = "",
  ariaLabel,
}) {
  const id = useId();

  // Normalize options: accept ["A","B"] or [{label,value}]
  const items = options.map((o) => (typeof o === "string" ? { label: o, value: o } : o));

  // Support both react-hook-form register and controlled mode
  const inputProps = register
    ? { ...register(name, rules) }
    : { value, onChange: onChange ? (e) => onChange(e.target.value) : undefined, onBlur };

  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-palette-gray-heading mb-1">
          {label} {required && <span className="text-palette-rose-hover">*</span>}
        </label>
      )}

      <select
        id={id}
        name={name}
        required={required}
        disabled={disabled}
        aria-label={ariaLabel}
        className="w-full rounded-lg border border-palette-gray-border bg-white px-3 py-2 text-sm text-palette-gray-primary shadow-sm
                   transition focus:border-palette-indigo-label focus:ring-2 focus:ring-palette-indigo-border focus:outline-none
                   disabled:bg-palette-gray-soft disabled:text-palette-gray-placeholder disabled:cursor-not-allowed"
        {...inputProps}
      >
        {emptyOption ? <option value=""></option> : null}
        {!emptyOption && placeholder ? (
          <option value="" disabled>
            {placeholder}
          </option>
        ) : null}
        {items.map((opt) => (
          <option key={String(opt.value)} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      {showError && error && <p className="mt-1 text-xs text-palette-rose-hover">{error}</p>}
    </div>
  );
}
